var map = {
	"./$pac.svg": 80139,
	"./0xbtc.svg": 37237,
	"./2give.svg": 53313,
	"./aave.svg": 78618,
	"./abt.svg": 5308,
	"./act.svg": 89888,
	"./actn.svg": 2233,
	"./ada.svg": 57436,
	"./add.svg": 22215,
	"./adx.svg": 55276,
	"./ae.svg": 54144,
	"./aeon.svg": 39853,
	"./aeur.svg": 31151,
	"./agi.svg": 79331,
	"./agrs.svg": 33894,
	"./aion.svg": 74436,
	"./algo.svg": 40494,
	"./amb.svg": 55051,
	"./amp.svg": 48230,
	"./ampl.svg": 11782,
	"./ankr.svg": 20929,
	"./ant.svg": 4356,
	"./apex.svg": 30036,
	"./appc.svg": 66388,
	"./ardr.svg": 19564,
	"./arg.svg": 30330,
	"./ark.svg": 93098,
	"./arn.svg": 95969,
	"./arnx.svg": 54146,
	"./ary.svg": 1409,
	"./ast.svg": 46776,
	"./atm.svg": 71589,
	"./atom.svg": 15343,
	"./audr.svg": 70848,
	"./auto.svg": 17011,
	"./aywa.svg": 17668,
	"./bab.svg": 72699,
	"./bal.svg": 3527,
	"./band.svg": 53846,
	"./bat.svg": 34768,
	"./bay.svg": 54840,
	"./bcbc.svg": 98668,
	"./bcc.svg": 14210,
	"./bcd.svg": 55022,
	"./bch.svg": 6385,
	"./bcio.svg": 19032,
	"./bcn.svg": 65178,
	"./bco.svg": 9825,
	"./bcpt.svg": 99788,
	"./bdl.svg": 64011,
	"./beam.svg": 38086,
	"./bela.svg": 8993,
	"./bix.svg": 38458,
	"./blcn.svg": 84700,
	"./blk.svg": 13871,
	"./block.svg": 10841,
	"./blz.svg": 5072,
	"./bnb.svg": 70705,
	"./bnt.svg": 88944,
	"./bnty.svg": 35468,
	"./booty.svg": 91389,
	"./bos.svg": 40649,
	"./bpt.svg": 23044,
	"./bq.svg": 15041,
	"./brd.svg": 37225,
	"./bsd.svg": 51635,
	"./bsv.svg": 92228,
	"./btc.svg": 87083,
	"./btcd.svg": 75100,
	"./btch.svg": 95365,
	"./btcp.svg": 76402,
	"./btcz.svg": 70729,
	"./btdx.svg": 42926,
	"./btg.svg": 17607,
	"./btm.svg": 39109,
	"./bts.svg": 21052,
	"./btt.svg": 65882,
	"./btx.svg": 51647,
	"./burst.svg": 47809,
	"./bze.svg": 35520,
	"./call.svg": 6348,
	"./cc.svg": 67555,
	"./cdn.svg": 73416,
	"./cdt.svg": 99227,
	"./cenz.svg": 35939,
	"./chain.svg": 26866,
	"./chat.svg": 3608,
	"./chips.svg": 29429,
	"./chsb.svg": 66235,
	"./cix.svg": 93629,
	"./clam.svg": 78336,
	"./cloak.svg": 72040,
	"./cmm.svg": 57132,
	"./cmt.svg": 36902,
	"./cnd.svg": 94656,
	"./cnx.svg": 43426,
	"./cny.svg": 11813,
	"./cob.svg": 57557,
	"./colx.svg": 86378,
	"./comp.svg": 24790,
	"./coqui.svg": 62321,
	"./cred.svg": 27627,
	"./crpt.svg": 62788,
	"./crv.svg": 89652,
	"./crw.svg": 89733,
	"./cs.svg": 14608,
	"./ctr.svg": 7859,
	"./ctxc.svg": 47994,
	"./cvc.svg": 70173,
	"./d.svg": 17666,
	"./dai.svg": 59693,
	"./dash.svg": 16175,
	"./dat.svg": 14537,
	"./data.svg": 66753,
	"./dbc.svg": 63647,
	"./dcn.svg": 4838,
	"./dcr.svg": 31921,
	"./deez.svg": 5153,
	"./dent.svg": 21461,
	"./dew.svg": 22589,
	"./dgb.svg": 21812,
	"./dgd.svg": 77902,
	"./dlt.svg": 52877,
	"./dnt.svg": 30643,
	"./dock.svg": 36588,
	"./doge.svg": 94344,
	"./dot.svg": 41683,
	"./drgn.svg": 81896,
	"./drop.svg": 19781,
	"./dta.svg": 23737,
	"./dth.svg": 46893,
	"./dtr.svg": 82445,
	"./ebst.svg": 87635,
	"./eca.svg": 40878,
	"./edg.svg": 18553,
	"./edo.svg": 49662,
	"./edoge.svg": 37919,
	"./ela.svg": 4989,
	"./elec.svg": 20845,
	"./elf.svg": 23832,
	"./elix.svg": 88566,
	"./ella.svg": 77691,
	"./emb.svg": 13483,
	"./emc.svg": 72497,
	"./emc2.svg": 69590,
	"./eng.svg": 26088,
	"./enj.svg": 43000,
	"./entrp.svg": 36185,
	"./eon.svg": 68251,
	"./eop.svg": 20431,
	"./eos.svg": 86981,
	"./eqli.svg": 58718,
	"./equa.svg": 45944,
	"./etc.svg": 33550,
	"./eth.svg": 18475,
	"./ethos.svg": 31935,
	"./etn.svg": 78438,
	"./etp.svg": 61425,
	"./eur.svg": 83338,
	"./evx.svg": 56095,
	"./exmo.svg": 4836,
	"./exp.svg": 67168,
	"./fair.svg": 30162,
	"./fct.svg": 23338,
	"./fil.svg": 22827,
	"./fjc.svg": 7899,
	"./fldc.svg": 13333,
	"./flo.svg": 37928,
	"./flux.svg": 83801,
	"./fsn.svg": 79042,
	"./ftc.svg": 77601,
	"./fuel.svg": 89542,
	"./fun.svg": 52910,
	"./game.svg": 12938,
	"./gas.svg": 62584,
	"./gbp.svg": 15450,
	"./gbx.svg": 46691,
	"./gbyte.svg": 24214,
	"./generic.svg": 26259,
	"./gin.svg": 34969,
	"./glxt.svg": 42680,
	"./gmr.svg": 45232,
	"./gno.svg": 30994,
	"./gnt.svg": 6177,
	"./gold.svg": 61463,
	"./grc.svg": 79077,
	"./grin.svg": 96491,
	"./grs.svg": 36741,
	"./grt.svg": 63024,
	"./gsc.svg": 36846,
	"./gto.svg": 54735,
	"./gup.svg": 64047,
	"./gusd.svg": 83232,
	"./gvt.svg": 11386,
	"./gxs.svg": 42469,
	"./gzr.svg": 10874,
	"./hight.svg": 58461,
	"./hns.svg": 29026,
	"./hodl.svg": 44970,
	"./hot.svg": 75151,
	"./hpb.svg": 45476,
	"./hsr.svg": 77924,
	"./ht.svg": 1571,
	"./html.svg": 69509,
	"./huc.svg": 63218,
	"./husd.svg": 8354,
	"./hush.svg": 10236,
	"./icn.svg": 86393,
	"./icp.svg": 18817,
	"./icx.svg": 72430,
	"./ignis.svg": 72996,
	"./ilk.svg": 727,
	"./ink.svg": 68655,
	"./ins.svg": 120,
	"./ion.svg": 96237,
	"./iop.svg": 75123,
	"./iost.svg": 43759,
	"./iotx.svg": 65459,
	"./iq.svg": 93134,
	"./itc.svg": 79763,
	"./jnt.svg": 70869,
	"./jpy.svg": 73291,
	"./kcs.svg": 99989,
	"./kin.svg": 91044,
	"./klown.svg": 40090,
	"./kmd.svg": 75885,
	"./knc.svg": 22374,
	"./krb.svg": 78910,
	"./ksm.svg": 79407,
	"./lbc.svg": 54069,
	"./lend.svg": 40337,
	"./leo.svg": 30028,
	"./link.svg": 39910,
	"./lkk.svg": 33778,
	"./loom.svg": 17030,
	"./lpt.svg": 9794,
	"./lrc.svg": 14065,
	"./lsk.svg": 96972,
	"./ltc.svg": 63164,
	"./lun.svg": 65051,
	"./maid.svg": 34737,
	"./mana.svg": 35632,
	"./matic.svg": 47310,
	"./max.svg": 32365,
	"./mcap.svg": 53214,
	"./mco.svg": 56851,
	"./mda.svg": 99580,
	"./mds.svg": 7769,
	"./med.svg": 31104,
	"./meetone.svg": 36963,
	"./mft.svg": 29760,
	"./miota.svg": 81905,
	"./mith.svg": 76642,
	"./mkr.svg": 50115,
	"./mln.svg": 28332,
	"./mnx.svg": 66620,
	"./mnz.svg": 62976,
	"./moac.svg": 68119,
	"./mod.svg": 39267,
	"./mona.svg": 83323,
	"./msr.svg": 16587,
	"./mth.svg": 87252,
	"./mtl.svg": 4830,
	"./music.svg": 93450,
	"./mzc.svg": 16841,
	"./nano.svg": 28218,
	"./nas.svg": 80829,
	"./nav.svg": 54649,
	"./ncash.svg": 714,
	"./ndz.svg": 84551,
	"./nebl.svg": 72634,
	"./neo.svg": 39078,
	"./neos.svg": 56611,
	"./neu.svg": 99977,
	"./nexo.svg": 96823,
	"./ngc.svg": 89413,
	"./nio.svg": 90551,
	"./nkn.svg": 88102,
	"./nlc2.svg": 32507,
	"./nlg.svg": 5032,
	"./nmc.svg": 38764,
	"./nmr.svg": 25883,
	"./npxs.svg": 57681,
	"./ntbc.svg": 9816,
	"./nuls.svg": 44513,
	"./nxs.svg": 1692,
	"./nxt.svg": 62126,
	"./oax.svg": 30233,
	"./ok.svg": 68597,
	"./omg.svg": 76696,
	"./omni.svg": 53572,
	"./one.svg": 93316,
	"./ong.svg": 12306,
	"./ont.svg": 6704,
	"./oot.svg": 28884,
	"./ost.svg": 7521,
	"./ox.svg": 38845,
	"./oxt.svg": 47274,
	"./part.svg": 86558,
	"./pasc.svg": 89946,
	"./pasl.svg": 77982,
	"./pax.svg": 36492,
	"./paxg.svg": 96505,
	"./pay.svg": 90549,
	"./payx.svg": 57122,
	"./pink.svg": 62847,
	"./pirl.svg": 9644,
	"./pivx.svg": 91338,
	"./plr.svg": 53231,
	"./poa.svg": 18038,
	"./poe.svg": 94118,
	"./polis.svg": 59684,
	"./poly.svg": 20519,
	"./pot.svg": 35240,
	"./powr.svg": 84868,
	"./ppc.svg": 11370,
	"./ppp.svg": 7276,
	"./ppt.svg": 54830,
	"./pre.svg": 51449,
	"./prl.svg": 30524,
	"./pungo.svg": 95225,
	"./pura.svg": 52594,
	"./qash.svg": 86759,
	"./qiwi.svg": 80867,
	"./qlc.svg": 60523,
	"./qrl.svg": 2083,
	"./qsp.svg": 58330,
	"./qtum.svg": 48502,
	"./r.svg": 52433,
	"./rads.svg": 48534,
	"./rap.svg": 36940,
	"./rcn.svg": 27003,
	"./rdd.svg": 52136,
	"./rdn.svg": 52498,
	"./ren.svg": 67762,
	"./rep.svg": 56595,
	"./repv2.svg": 56223,
	"./req.svg": 32938,
	"./rhoc.svg": 3528,
	"./ric.svg": 22992,
	"./rise.svg": 33636,
	"./rlc.svg": 51510,
	"./rpx.svg": 24550,
	"./rub.svg": 36491,
	"./rvn.svg": 7716,
	"./ryo.svg": 5480,
	"./safe.svg": 13538,
	"./safemoon.svg": 74884,
	"./sai.svg": 96462,
	"./salt.svg": 59586,
	"./san.svg": 72952,
	"./sand.svg": 50326,
	"./sbd.svg": 82837,
	"./sberbank.svg": 78248,
	"./sc.svg": 64096,
	"./shift.svg": 84856,
	"./sib.svg": 34366,
	"./sin.svg": 65173,
	"./skl.svg": 52182,
	"./sky.svg": 13714,
	"./slr.svg": 34913,
	"./sls.svg": 43287,
	"./smart.svg": 68540,
	"./sngls.svg": 34148,
	"./snm.svg": 58007,
	"./snt.svg": 25085,
	"./snx.svg": 77586,
	"./soc.svg": 97379,
	"./sol.svg": 89472,
	"./spacehbit.svg": 27342,
	"./spank.svg": 20235,
	"./sphtx.svg": 52275,
	"./srn.svg": 35587,
	"./stak.svg": 35331,
	"./start.svg": 66166,
	"./steem.svg": 50610,
	"./storj.svg": 60680,
	"./storm.svg": 38029,
	"./stox.svg": 10918,
	"./stq.svg": 68598,
	"./strat.svg": 22133,
	"./stx.svg": 16778,
	"./sub.svg": 3319,
	"./sumo.svg": 25904,
	"./sushi.svg": 69163,
	"./sys.svg": 60,
	"./taas.svg": 30274,
	"./tau.svg": 93228,
	"./tbx.svg": 71053,
	"./tel.svg": 49694,
	"./ten.svg": 53372,
	"./tern.svg": 91925,
	"./tgch.svg": 23133,
	"./theta.svg": 3636,
	"./tix.svg": 9007,
	"./tkn.svg": 27403,
	"./tks.svg": 15971,
	"./tnb.svg": 28447,
	"./tnc.svg": 34702,
	"./tnt.svg": 74147,
	"./tomo.svg": 52996,
	"./tpay.svg": 11369,
	"./trig.svg": 40486,
	"./trtl.svg": 43080,
	"./trx.svg": 95224,
	"./tusd.svg": 24048,
	"./tzc.svg": 40938,
	"./ubq.svg": 91719,
	"./uma.svg": 57309,
	"./uni.svg": 39621,
	"./unity.svg": 92957,
	"./usd.svg": 94543,
	"./usdc.svg": 24227,
	"./usdt.svg": 52257,
	"./utk.svg": 16161,
	"./veri.svg": 10075,
	"./vet.svg": 97977,
	"./via.svg": 9790,
	"./vib.svg": 86095,
	"./vibe.svg": 51059,
	"./vivo.svg": 86676,
	"./vrc.svg": 89787,
	"./vrsc.svg": 69662,
	"./vtc.svg": 78167,
	"./vtho.svg": 574,
	"./wabi.svg": 88749,
	"./wan.svg": 19403,
	"./waves.svg": 45840,
	"./wax.svg": 8899,
	"./wbtc.svg": 39069,
	"./wgr.svg": 92831,
	"./wicc.svg": 18900,
	"./wings.svg": 38036,
	"./wpr.svg": 75549,
	"./wtc.svg": 98331,
	"./x.svg": 59899,
	"./xas.svg": 73119,
	"./xbc.svg": 88627,
	"./xbp.svg": 87862,
	"./xby.svg": 42156,
	"./xcp.svg": 86259,
	"./xdn.svg": 69577,
	"./xem.svg": 13216,
	"./xin.svg": 71223,
	"./xlm.svg": 18687,
	"./xmcc.svg": 26623,
	"./xmg.svg": 92401,
	"./xmo.svg": 58568,
	"./xmr.svg": 26372,
	"./xmy.svg": 40975,
	"./xp.svg": 76981,
	"./xpa.svg": 10591,
	"./xpm.svg": 54067,
	"./xpr.svg": 12346,
	"./xrp.svg": 2384,
	"./xsg.svg": 16310,
	"./xtz.svg": 77234,
	"./xuc.svg": 97307,
	"./xvc.svg": 35920,
	"./xvg.svg": 11668,
	"./xzc.svg": 70281,
	"./yfi.svg": 75270,
	"./yoyow.svg": 38678,
	"./zcl.svg": 3662,
	"./zec.svg": 74097,
	"./zel.svg": 36803,
	"./zen.svg": 73404,
	"./zest.svg": 37094,
	"./zil.svg": 83426,
	"./zilla.svg": 45517,
	"./zrx.svg": 72331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45370;